import { SignDocumentRequest } from "@/shared/domain";

export const customerCardSignDefaultValues = (
    policyHolderId: number,
    requestId: string,
    signedBy: string,
    signedIn: string,
): SignDocumentRequest => ({
    policyHolderId,
    requestId,
    signedBy,
    signedOn: new Date(),
    signedIn,
    approved: false,
});
